import React, { useCallback, useEffect, useState, useRef, useContext } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Tabs, Card, Icon, Button } from 'antd';
import ComplexDocumentHistoryProvider, {
  useDocumentContext,
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
} from '../../context/complexDocumentContext';
import ComplexArtboardProvider, {
  CONTEXT_KEYS,
  useArtboardContext,
} from '../../context/complexArtboardContext';
import BusinessLogicProvider from '../../context/businessLogicContext';
import FontsProvider from '../../context/fontsContext';
import { EmailSubjectIcon } from '../../images/svgIcons';

import ComplexArtboard from './ComplexArtboard';

import { ComplexPreviewTabsContainer, DocumentContainer, Overlay, OverlayText } from './styles';
import { getDocumentDetails as getAccessibilityDetails } from './accessibilityHelper';
import { ImageView } from './styles';
import ColorContrastValidator from '../../components/Accessibility/ColorContrastValidator';
import { ACCESSIBILITY_TOOL_TIPS, ACCESSIBILITY_VALIDATOR_TRANSLATION } from '../ComplexDocumentDesign/translationValues'
import { tickSvg, percentageSvg, tickSvg1, BlockHighlighter } from '../ComplexDocumentDesign/styles'
import { Collapse } from 'antd';
import AccessibilitySummaryEditor from '../SidebarMenu/AccessibilitySummaryEditor';
import { AccessibilityContent } from '../../components/Accessibility/style';
import PageElementsProvider from '../../context/pageElementsContext';
import GetAlternativeTextFromValidator from '../../components/Accessibility/getAlternativeTextFromValidator';
import { getAccessibilityPercentage } from './accessibilityHelper';
import GetBlockSummaryFromValidator from '../../components/Accessibility/getBlockSummaryFromValidator'
import { ACCESSIBILITY_PREVIEW } from './complexVariables/translationValues';
import blankCanvas from '../../images/blank-canvas.png'
import { FullPageLoaderContainer } from '../../artboard/styles';
import Loader from '../../components/Loader';

import { EMAIL_TEMPLATES_MENUBAR, COMPLEX_EMAIL_SETTINGS } from '../ComplexEmailDesign/translationValues';
import ComplexEmailArtboard from '../ComplexEmailDesign/ComplexEmailArtboard';
import styled from 'styled-components';
const { Panel } = Collapse;


const NAMESPACES = ['ACCESSIBILITY_VALIDATOR_TRANSLATION'];

const OVERRIDE_ARTBOARD_STATE = {
  [CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN]: false,
  [CONTEXT_KEYS.ENABLE_RULER]: false,
  [CONTEXT_KEYS.RULER_WIDTH_ADJUSTER]: true,
  [CONTEXT_KEYS.DISABLE_VARIABLE_MENTION]: true,
  [CONTEXT_KEYS.CHECK_ACCESSIBILITY]: true
}

const ComplexDocumentAccessibilityValidator = ({ visible, isEmail, emailSubject, handleSubjectValidator, setDefaultSidebarTab, attachments }) => {
  const { t } = useTranslation(NAMESPACES);
  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [currentDesign, updateArtboard] = useArtboardContext(getCurrentDesign, 'ComplexDocumentAccessibilityValidator');
  const [accessibilityContext, setAccessibilityContext] = useState(undefined);
  const contextSelector = useCallback(store => store, []);
  const [documentContext] = useDocumentContext(contextSelector);
  const [percentage, setPercentage] = useState(0);
  const docDesign = useRef();
  const [viewImages, setViewImages] = useState(false);
  const [viewContrast, setViewContrast] = useState(false);
  const [summaryInput, setSummaryInput] = useState({});
  const [viewDocSummary, setViewDocSummary] = useState(false);
  const [viewBlockSummary, setViewBlockSummary] = useState(false);
  const [summarySave, setSummarySave] = useState(false);
  const [blockSummarySave, setBlockSummarySave] = useState(false);
  const [docSummarySave, setDocSummarySave] = useState(false);
  const currentElement = useRef();
  const flowID = useRef();
  const currentBlockID = useRef();
  const resolveVisible = useRef(0);
  const [showContent,setShowContent] = useState(false);
  
  const customCurrentBlockSelector = useCallback(store => store[CONTEXT_KEYS.CURRENT_BLOCK], []);
  const [currentEditingBlock] = useArtboardContext(customCurrentBlockSelector);

  const customSelector = useCallback(store => store[currentElement.current], []);
  const [creativeBlock, methods] = useDocumentContext(customSelector, `DesignBlock-${currentElement.current}`);

  const customVarSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES], []);
  const [globalVariables] = useDocumentContext(customVarSelector);

  const blockSelector = useCallback(store => store[CONTEXT_KEYS.CURRENT_BLOCK_SETTINGS], []);
  const [selectedBlockItem] = useArtboardContext(blockSelector, `BlockLayoutSettings-${flowID.current}`);

  const designSummarySelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.DESIGN_SUMMARY], []);
  const [summary] = useDocumentContext(designSummarySelector, ``);

  const customSelector1 = useCallback(store => store[currentBlockID.current], [currentBlockID.current]);
  const [currentBlock] = useDocumentContext(customSelector1, `Block-${currentBlockID.current}`);

  const isReadOnlySelector = useCallback(store => store[CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN], []);
  const [isEditMode] = useArtboardContext(isReadOnlySelector, `ComplexSettingsTab`);

  const accessibilitySelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_ACCESSIBLE], []);
  const [accessibilityEnabled] = useDocumentContext(accessibilitySelector, `ComplexSettingsTab`);

  const artboardVersionSelector = useCallback(store => store[CONTEXT_KEYS.ARTBOARD_VERSION], []);
  const [artboardVersion] = useArtboardContext(artboardVersionSelector, `ComplexVariablesList`);

  const readonlySelector = useCallback(store => store[CONTEXT_KEYS.READONLY_TEMPLATE], []);
  const [readOnly] = useArtboardContext(readonlySelector, `ComplexVariablesList`);

   useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true); 
    }, 500); 
    return () => clearTimeout(timer); 
  }, []);

  useEffect(() => {
    if (visible) {
      setSummarySave(false)
      setBlockSummarySave(false)
      updateArtboard({
        [CONTEXT_KEYS.CHECK_ACCESSIBILITY]: true,
        [CONTEXT_KEYS.BLOCK_NAVIGATE_AND_HIGHLIGHT]: false,
      });
    } else {
      updateArtboard({ [CONTEXT_KEYS.CHECK_ACCESSIBILITY]: false });
    }
    return () => {
      updateArtboard({ [CONTEXT_KEYS.CHECK_ACCESSIBILITY]: false });
    }
  }, [visible]);

  useEffect(() => {
    setSummarySave(false)
    setBlockSummarySave(false)
    const accessibilityContext = getAccessibilityDetails({
      documentContext,
      currentDesign,
      docDesign,
      isEmail,
      emailSubject,
      attachments
    });
    setAccessibilityContext(accessibilityContext); // To populate To Fix and percentage
    const getPercentage = Math.round(getAccessibilityPercentage(accessibilityContext, isEmail, emailSubject, currentDesign));
    resolveVisible.current = getPercentage === 100 ? 0 : 1;
    setPercentage(getPercentage)
  }, [visible, summarySave, blockSummarySave, docSummarySave]);

  const setSelectedBlock = useCallback((selectedBlock) => {
    updateArtboard({ [CONTEXT_KEYS.CURRENT_BLOCK_SETTINGS]: selectedBlock });
  }, []);

  const updateCreativeBlockElements = useCallback((contents) => {
    if(!isEmail) {
      let itemType = 'creative'
      methods.updateBlock('contents', currentElement.current, { contents, flowUUID: flowID.current, type: itemType }, true, globalVariables);
    }
  }, [flowID.current]);

  const variablesSelector = useCallback(
      store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES],
      [],
    );
  const [globalVariables1, store] = useDocumentContext(
    variablesSelector
  );
  
  const updateSocialMediaContent = useCallback((newContent, socialMediaType, blockUUID) => {
    if(newContent[0].content && newContent[0].content.trim().length) {
      const existingContent = store.get()[blockUUID]?.contents;
      existingContent.map((el, elIndex) => {
        if (el.contentType === socialMediaType) {
          if(existingContent[elIndex].summary && existingContent[elIndex].summary[0]) {
            existingContent[elIndex].summary[0].content = '';
          }
          existingContent[elIndex].summary = newContent;
        }
        return el;
      });
      methods.updateBlock('link-block', blockUUID, { contents: existingContent, flowUUID: flowID.current, type: 'block'});
      setSummaryInput({});
    }
  })

  const onDocumentSummarySave = useCallback(({ contents, newGlobalVariables }) => {
    const hasSummary = contents?.some(item => {
      const content = item.content?.trim();
      return content && content !== '\n';
    });
    setAccessibilityContext(prevData => ({
      ...prevData,
      document: {
        ...prevData.document,
        summary: hasSummary
      }
    }));
    methods.updateSummary(contents, newGlobalVariables);
    setDocSummarySave(true)
  }, []);

  const onBlockSummarySave = (changes, item, flowID1) => {
    const details = {
      summary: changes.contents,
      flowUUID: flowID1,
      type: changes.type,
    };
    methods.updateBlock('summary', item.blockUUID, details);
    setBlockSummarySave(true);
  };

  const handleClick = (item) => {

    resolveVisible.current = 1;
    if (item === 'Image') {
      setViewImages(true)
    }
    if (item === 'Contrast') {
      setViewContrast(true)
    }
    if (item === 'DocumentSummary') {
      setViewDocSummary(true)
    }
    if (item === 'EmailSubject') {
      handleSubjectValidator();
    }
    if (item === 'BlockSummary') {
      setViewBlockSummary(true)
    }
  }

  const contrastSvg = () => (
    <svg
      height="20px"
      width="20px"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle fill="#F2F2F4" cx="256" cy="256" r="256" />
      <path
        fill="#56545A"
        d="M256,0v512c141.385,0,256-114.615,256-256S397.385,0,256,0z"
      />
    </svg>
  );

  const navigateIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 320 448"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>navigate-external</title>
      <g transform="translate(0,-604.36224)">
        <path
          d="M 0 64 L 0 96 L 0 352 L 0 384 L 320 384 L 320 352 L 320 256 L 288 256 L 288 352 L 32 352 L 32 96 L 128 96 L 128 64 L 32 64 L 0 64 z"
          transform="translate(0,604.36224)"
          fill="#fff"
        />
        <path
          d="M 192 64 L 192 96 L 265.19 96 L 128 233.64 L 150.92 256 L 288 118.47 L 288 192 L 320 192 L 320 86.36 L 320 64 L 297.08 64 L 192 64 z"
          transform="translate(0,604.36224)"
          fill="#fff"
        />
      </g>
    </svg>
  );

  const backToHome = () => {
    resolveVisible.current = 0;
    setViewImages(false);
    setViewContrast(false);
    setViewDocSummary(false);
    setViewBlockSummary(false);
  }

  const getAltText = (index, item, current_flowID) => {
    currentElement.current = item.blockUUID;
    flowID.current = current_flowID;
    setSummaryInput(prev => ({ ...prev, [isEmail ? index : item.elementUUID]: true }));
  }

  const inputSummary = () => {
    return (
      <>
        <AccessibilityContent isAltText={true}>
          <AccessibilitySummaryEditor
            itemUUID={'doc-summary-from-validator'}
            contents={summary?.contents}
            customContainerStyle={{ marginTop: 10 }}
            onSaveChanges={onDocumentSummarySave}
            customizeHistory={false}
            customClassName={'summary-editor'}
          />
        </AccessibilityContent>
      </>
    )
  }

  const inputAltText = (index, item, flowID, flow) => {

    let blockDetails = documentContext[item.blockUUID]
    if (blockDetails.blockType === "static_table") {
      blockDetails = documentContext[item.elementUUID]
      currentElement.current = item.elementUUID
    }
    
    return (
      <>
        {((isEmail && summaryInput[index]) || summaryInput[item.elementUUID])  && (
          <AccessibilityContent isAltText={true}>
            <PageElementsProvider
              parentElements={blockDetails.contents}
              setParentElements={updateCreativeBlockElements}
            >
              <GetAlternativeTextFromValidator
                elementUUID={item.elementUUID}
                blockID={item.blockUUID}
                flowID={flowID}
                setSummarySave={setSummarySave}
                globalVariables={globalVariables}
                accessibilityContext={accessibilityContext}
                setAccessibilityContext={setAccessibilityContext}
                flow={flow}
                isEmail={isEmail}
                socialMediaType={item.socialMediaType}
                updateSocialMediaContent={updateSocialMediaContent}
              />
            </PageElementsProvider>
          </AccessibilityContent>
        )}
      </>
    );
  }

  const handleChange = () => {
    setSummaryInput({});
  }

  const scrollToElement = (flowUUID, blockUUID, elementUUID = '') => {
    docDesign.current = null;
    const complexPageWrapper = document.getElementById('complex-page-wrapper');

    updateArtboard({
      [CONTEXT_KEYS.CHECK_ACCESSIBILITY]: false
    });

    const editingContainerDOM = document.getElementById(`editingContainer-${flowUUID}-0`);

    editingContainerDOM && editingContainerDOM.dispatchEvent(new CustomEvent('alreadyScrolled'));

    setTimeout(() => {
      const blockElement = document.getElementById(blockUUID);
      const blockRect = blockElement.getBoundingClientRect();
      complexPageWrapper.scrollTo({ top: blockRect.top - 500, behavior: 'smooth' });
      setTimeout(() => {
        blockElement.dispatchEvent(
          new CustomEvent('highlightElement', { detail: { elementUUID: elementUUID } }),
        );
      }, 10);

      setTimeout(() => {
        updateArtboard({
          [CONTEXT_KEYS.SWITCH_CREATIVE_DESIGN_MENU]: true,
          // [CONTEXT_KEYS.BLOCK_SETTINGS_VISIBLE]: true,
          [CONTEXT_KEYS.CURRENT_BLOCK]: blockUUID,
          [CONTEXT_KEYS.CURRENT_BLOCK_TYPE]: 'creative_block',
          [CONTEXT_KEYS.CURRENT_PAGE]: flowUUID,
        });
      }, 100);

    }, 100);
  };

  const scrollToSettings = (flowUUID, blockUUID, type = '') => {

    docDesign.current = null;
    const complexPageWrapper = document.getElementById('complex-page-wrapper');

    setDefaultSidebarTab();

    const isSocialMediaLink = documentContext[blockUUID]?.blockType === 'link';

    updateArtboard({
      [CONTEXT_KEYS.CHECK_ACCESSIBILITY]: false,
      [CONTEXT_KEYS.BLOCK_NAVIGATE_AND_HIGHLIGHT]: true,
      [CONTEXT_KEYS.CURRENT_BLOCK_ID]: blockUUID,
      [CONTEXT_KEYS.CURRENT_FLOW_ID]: flowUUID,
      [CONTEXT_KEYS.BLOCK_SETTINGS_ACTIVE_TAB]: type === 'colorContrast'?'1':'2',
    });

    setTimeout(() => {
      const blockElement = document.getElementById(blockUUID);
      const blockRect = blockElement && blockElement.getBoundingClientRect();
      complexPageWrapper.scrollTo({ top: blockRect.top - 500, behavior: 'smooth' });
      !isSocialMediaLink && setTimeout(() => {
        updateArtboard({
          [CONTEXT_KEYS.BLOCK_SETTINGS_VISIBLE]: true,
        });
      }, 100);
    }, 100);

    setTimeout(()=>{
      updateArtboard({[CONTEXT_KEYS.BLOCK_SETTINGS_ACTIVE_TAB]:'1'})
    },1000)

    const editingContainerDOM = document.getElementById(`editingContainer-${flowUUID}-0`);
    editingContainerDOM && editingContainerDOM.dispatchEvent(new CustomEvent('alreadyScrolled'));

    requestAnimationFrame(() => {
      let selectItem = {
        item: documentContext[blockUUID],
        itemUUID: blockUUID,
        parentUUID: flowUUID,
        pageId: `${flowUUID}-0`,
      };
      if(isEmail && selectItem?.item.blockType === 'link') {
        updateArtboard({[CONTEXT_KEYS.CURRENT_BLOCK]: blockUUID, [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: true});
      }
      let target = document.getElementById(blockUUID);
      if (selectItem?.item.blockType === 'text') {
        target = document.getElementById(`q-container-${blockUUID}`);
      }
      let selectedBlockStyle;
      if (target) {
        let styles = target?.getBoundingClientRect();
        const editingContainer = document.getElementById(flowUUID);
        const pageContent = editingContainer.getBoundingClientRect();
        selectedBlockStyle = {
          top: parseFloat(styles?.top - pageContent.top).toFixed(3) + 'px',
          left: parseFloat(styles?.left - pageContent.left).toFixed(3) + 'px',
          width: parseFloat(styles?.width - 2).toFixed(3) + 'px',
          height: parseFloat(styles?.height).toFixed(3) + 'px',
          isVisible: 'visible',
        };
      }
      setSelectedBlock(selectItem)
    })

  }

  const getTitle = () => {
    return (
      <>
        {resolveVisible.current === 1 && percentage < 100 && <div style={{ color: 'white', marginTop: '14px', marginBottom: '0px', cursor: 'pointer' }} onClick={() => backToHome()}>
          <div className='title-style' style={{ color: 'white', marginLeft: '68px', gap: '2px' }} >
            <Icon type="arrow-left" />
            <strong style={{ marginLeft: '8px' }}>
              {t(
                ACCESSIBILITY_TOOL_TIPS.BACK_TO_ACCESSIBILITY.key,
                ACCESSIBILITY_TOOL_TIPS.BACK_TO_ACCESSIBILITY.value,
              )}
            </strong>
          </div>
        </div>}
      </>
    )
  }

  const ImgparentCard = () => {
    let ImageCount = 0, ContrastCount = 0, BlockSummaryCount = 0;
    if (accessibilityContext && accessibilityContext.flows) {
      accessibilityContext.flows.forEach((item) => {
        if (accessibilityContext[item]?.alternativeText) {
          ImageCount += accessibilityContext[item].alternativeText.length;
          BlockSummaryCount += accessibilityContext[item].summaries.length;
        }
        ContrastCount = ContrastCount + Object.keys(accessibilityContext[item].color).length
      });
    }
    const arr = [];
    if (isEmail && currentDesign === 'document' && (!emailSubject || emailSubject?.contents[0]?.content == '' || emailSubject?.contents[0]?.content == '\n')) {
      arr.push('EmailSubject');
    }
    if (!accessibilityContext?.document.summary) {
      arr.push('DocumentSummary');
    }
    if (BlockSummaryCount > 0) {
      arr.push('BlockSummary');
    }
    if (ImageCount > 0) {
      arr.push('Image');
    }
    if (ContrastCount > 0) {
      arr.push('Contrast');
    }
    return (
      <>
        {arr.map(item => {
          let iconType;
          let label;
          let issueCount;

          switch (item) {
            case 'DocumentSummary':
              iconType = isEmail ? 'email-summary' : 'file-pdf';
              label = isEmail ?
                t(
                  COMPLEX_EMAIL_SETTINGS.ACCESSIBILITY_SUMMARY.key,
                  COMPLEX_EMAIL_SETTINGS.ACCESSIBILITY_SUMMARY.value,
                ) :
                t(
                  ACCESSIBILITY_TOOL_TIPS.LIST_DOC_SUMMARY.key,
                  ACCESSIBILITY_TOOL_TIPS.LIST_DOC_SUMMARY.value,
                );
              issueCount = `1 ${t(
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.key,
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.value,
              )}`;
              break;
            case 'BlockSummary':
              iconType = 'form';
              label = t(
                ACCESSIBILITY_TOOL_TIPS.LIST_SECTION_SUMMARY.key,
                ACCESSIBILITY_TOOL_TIPS.LIST_SECTION_SUMMARY.value,
              );
              issueCount = `${BlockSummaryCount} ${t(
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.key,
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.value,
              )}`
              break;
            case 'EmailSubject':
              iconType = 'mail';
              label = t(
                EMAIL_TEMPLATES_MENUBAR.EMAIL_SUBJECT_ERROR.key,
                EMAIL_TEMPLATES_MENUBAR.EMAIL_SUBJECT_ERROR.value
              );
              issueCount = `1 ${t(
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.key,
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.value,
              )}`
              break;
            case 'Image':
              iconType = 'file-image';
              label = t(
                ACCESSIBILITY_TOOL_TIPS.LIST_ALT_TEXT.key,
                ACCESSIBILITY_TOOL_TIPS.LIST_ALT_TEXT.value,
              );
              issueCount = `${ImageCount} ${t(
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.key,
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.value,
              )}`;
              break;
            case 'Contrast':
              iconType = 'highlight';
              label = t(
                ACCESSIBILITY_TOOL_TIPS.LIST_COLOR_CONTRAST.key,
                ACCESSIBILITY_TOOL_TIPS.LIST_COLOR_CONTRAST.value,
              );
              issueCount = `${ContrastCount} ${t(
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.key,
                ACCESSIBILITY_TOOL_TIPS.TO_FIX.value,
              )}`;
              break;
   
            default:
              break;
          }

          return (
            <Card bordered={false} className='card-design' onClick={() => handleClick(item)} key={item}>
              <div className='card-view'>
                {item === 'Contrast' ? <Icon component={contrastSvg} /> : iconType === 'email-summary' ? <EmailSubjectIcon /> : <Icon className='icon-size' type={iconType} />}
                <strong style={{ width: '58%' }}>{label}</strong>
                  <div className='issues-card'>
                  {issueCount}
                </div>
              </div>
            </Card>
          );
        })}
      </>
    );

  }

  const childCard = (item) => {

    let ImageCount = 0, ContrastCount = 0, BlockSummaryCount = 0;
    if (accessibilityContext && accessibilityContext.flows) {
      accessibilityContext.flows.forEach((item) => {
        if (accessibilityContext[item]?.alternativeText) {
          ImageCount += accessibilityContext[item].alternativeText.length;
          BlockSummaryCount += accessibilityContext[item].summaries.length;
        }
        ContrastCount = ContrastCount + Object.keys(accessibilityContext[item].color).length
      });
    }

    switch (item) {
      case 'Image':
        resolveVisible.current = ImageCount === 0 ? 0 : 1;
        return (
          <>
            {ImageCount > 0 ? <div>
              {accessibilityContext.flows.map((flow) => {
                return (
                  <>
                    {accessibilityContext[flow]?.alternativeText?.length > 0 && <div style={{ marginTop: '8px' }}>
                      <Collapse bordered={false} onChange={handleChange} expandIconPosition={'right'} className='card-design' defaultActiveKey={['Page 1']}>
                        <Panel key={flow} header={
                          <div className='accordion-header'>
                            <span>{flow}</span>
                            <span style={{ marginRight: '4px',float: 'right' }}>
                              {t(
                                ACCESSIBILITY_TOOL_TIPS.FINDINGS.key,
                                ACCESSIBILITY_TOOL_TIPS.FINDINGS.value,
                              )}
                              {accessibilityContext[flow]?.alternativeText?.length}
                            </span>
                          </div>
                        }>
                          <div className='scrollable-section'>
                            {accessibilityContext[flow].alternativeText.map((item, idx) => (
                              <>
                                <Card
                                  key={`image-card-${flow}-${idx}`}
                                  className="ind-card"
                                >
                                  <div className="section-card">
                                    <div className='title-style' onClick={() => isEmail ? scrollToSettings(accessibilityContext[flow].flowUUID, item.blockUUID) : scrollToElement(accessibilityContext[flow].flowUUID, item.blockUUID, item.elementUUID)}>
                                      <Icon component={navigateIcon} />
                                      <p style={{ color: 'white', width: '90%' }}>
                                        {t(
                                          ACCESSIBILITY_TOOL_TIPS.NAVIGATE_TO_IMAGE.key,
                                          ACCESSIBILITY_TOOL_TIPS.NAVIGATE_TO_IMAGE.value,
                                        )}
                                      </p>
                                    </div>

                                    <Card className='img-card' bordered={false} onClick={() => isEmail ? scrollToSettings(accessibilityContext[flow].flowUUID, item.blockUUID) : scrollToElement(accessibilityContext[flow].flowUUID, item.blockUUID, item.elementUUID)}>
                                      <ImageView src={item.url} alt="droppable-image" style={isEmail && {backgroundColor: item.bgColor || '#000000'}} />
                                    </Card>
                                    <div className='section-card'>
                                      {!summaryInput[isEmail ? idx : item.elementUUID] && <Button onClick={() => getAltText(idx, item, accessibilityContext[flow].flowUUID)}>
                                        {t(
                                          ACCESSIBILITY_TOOL_TIPS.ALT_TEXT_BUTTON.key,
                                          ACCESSIBILITY_TOOL_TIPS.ALT_TEXT_BUTTON.value,
                                        )}
                                      </Button>}
                                      {summaryInput[isEmail ? idx : item.elementUUID] && inputAltText(idx, item, accessibilityContext[flow].flowUUID, flow)}
                                    </div>
                                  </div>
                                </Card>
                              </>
                            ))}
                          </div>
                        </Panel>
                      </Collapse>

                    </div>}
                  </>
                );
              })}
            </div> : ResolvedCard(ImageCount)}
          </>
        );
      case 'Contrast':
          resolveVisible.current = ContrastCount === 0 ? 0 : 1;
        return (
          <>
            {ContrastCount > 0 ? <div>
              {accessibilityContext.flows.map((flow) => {
                return (
                  <>
                 {accessibilityContext[flow]?.color && Object.keys(accessibilityContext[flow].color).length > 0&& <div style={{ marginTop: '8px' }}>
                    <Collapse bordered={false} expandIconPosition={'right'} className='card-design' defaultActiveKey={['Page 1']}>
                      <Panel key={flow} header={
                        <div className='accordion-header'>
                          <span>{flow}</span>
                          <span style={{ marginRight: '4px',float: 'right' }}>
                            {t(
                              ACCESSIBILITY_TOOL_TIPS.FINDINGS.key,
                              ACCESSIBILITY_TOOL_TIPS.FINDINGS.value,
                            )}
                            {Object.keys(accessibilityContext[flow].color).length}</span>
                        </div>
                      }>
                        <div className='scrollable-section'>
                          {Object.entries(accessibilityContext[flow].color).map(([blockUUID, item], idx) => {
                            flowID.current = accessibilityContext[flow].flowUUID;
                            return (
                              <Card
                                key={`contrast-card-${flow}-${idx}`}
                                className="ind-card"
                                bordered={false}
                                onClick={() => scrollToSettings(accessibilityContext[flow].flowUUID, blockUUID, 'colorContrast')}
                              >
                                <div className="section-card">
                                  <div className='title-style'>
                                    <Icon component={contrastSvg} />
                                    <p style={{ color: 'white', width: '86%' }}>
                                      {t(
                                        ACCESSIBILITY_TOOL_TIPS.TAP_TO_SECTION.key,
                                        ACCESSIBILITY_TOOL_TIPS.TAP_TO_SECTION.value,
                                      )}
                                    </p>
                                  </div>
                                  <ColorContrastValidator
                                    key={`contrast-${flow}-${idx}`}
                                    containerBackgroundColor={item[0]?.backgroundColor}
                                    textColor={item[0]?.textColor}
                                    containerText={item[0]?.content}
                                    fontSize={item[0]?.fontSize}
                                  />
                                  <p>
                                    {t(
                                      ACCESSIBILITY_TOOL_TIPS.COLOR_CONTRAST_INFO.key,
                                      ACCESSIBILITY_TOOL_TIPS.COLOR_CONTRAST_INFO.value,
                                    )}
                                  </p>
                                </div>
                              </Card>
                            );
                          })}
                        </div>
                      </Panel>
                    </Collapse>
                  </div>}
                  </>
                );
              })}
            </div> : ResolvedCard(ContrastCount)}
          </>
        );
      case 'DocumentSummary':
        return (
          <>
            {!accessibilityContext?.document.summary ? <div style={{ marginTop: '8px' }}>

              <div className='scrollable-section'>
                <>
                  <Card
                    className="ind-card card-design"
                  >
                    <div className="section-card">
                      <div className='title-style'>
                        {isEmail ?
                        <EmailSubjectIcon /> :
                        <Icon type="file-image" /> }
                        <p style={{ color: 'white', width: '90%' }}>
                          {isEmail ? t(
                            ACCESSIBILITY_TOOL_TIPS.DESCRIPTIVE_EMAIL_SUMMARY.key,
                            ACCESSIBILITY_TOOL_TIPS.DESCRIPTIVE_EMAIL_SUMMARY.value,
                          ) :
                          t(
                            ACCESSIBILITY_TOOL_TIPS.DESCRIPTIVE_DOCUMENT_SUMMARY.key,
                            ACCESSIBILITY_TOOL_TIPS.DESCRIPTIVE_DOCUMENT_SUMMARY.value,
                          )}
                        </p>
                      </div>
                      <div className='section-card'>
                        {inputSummary()}
                      </div>
                    </div>
                  </Card>
                </>
              </div>

            </div> : ResolvedCard(resolveVisible.current)}

          </>
        );
      case 'BlockSummary':
          resolveVisible.current = BlockSummaryCount === 0 ? 0 : 1;
        return (
          <>
            {BlockSummaryCount > 0 ?
              <GetBlockSummaryFromValidator accessibilityContext={accessibilityContext} setAccessibilityContext={setAccessibilityContext} onBlockSummarySave={onBlockSummarySave} scrollToElement={scrollToSettings} />
              : ResolvedCard(BlockSummaryCount)}
          </>
        );
      default:
        return null;
    }
  };

  const ResolvedCard = (count) => {
    resolveVisible.current = count === 0? count: 1;
    return (
      <div class="success-card">
        {tickSvg1()}
        <h2 class="success-title">
          {t(
            ACCESSIBILITY_TOOL_TIPS.RESOLVED_CARD_HEADING.key,
            ACCESSIBILITY_TOOL_TIPS.RESOLVED_CARD_HEADING.value,
          )
          }  
        </h2>
        <p class="success-message">
          {t(
            ACCESSIBILITY_TOOL_TIPS.RESOLVED_CARD_INFO.key,
            ACCESSIBILITY_TOOL_TIPS.RESOLVED_CARD_INFO.value,
          )
          }  <br />
          {isEmail ?
          t(
            ACCESSIBILITY_TOOL_TIPS.EMAIL_RESOLVED_CARD_INFO_MESSAGE.key,
            ACCESSIBILITY_TOOL_TIPS.EMAIL_RESOLVED_CARD_INFO_MESSAGE.value,
          ) : t(
            ACCESSIBILITY_TOOL_TIPS.RESOLVED_CARD_INFO_MESSAGE.key,
            ACCESSIBILITY_TOOL_TIPS.RESOLVED_CARD_INFO_MESSAGE.value,
          )
          }  
        </p>
        <Button class="back-button" onClick={() => backToHome()}><Icon type="double-right" />Let's Continue</Button>
      </div>
    );
  };

  const getAccessibilityDesign = () => {
    const vobj = docDesign.current?.flows;
    const hasSummary = docDesign?.current?.summary?.contents ? docDesign.current.summary.contents.some(item => {
      const content = item.content?.trim();
      return content && content !== '\n';
    }) : false;
    let len = 0;
    let flag=0;
    let totalBlocks = 0;
    vobj && Object.entries(vobj).forEach(([key, value]) => {   
      totalBlocks = value.blocks?.length;
      for(let i=0; i<totalBlocks;i++){   
      len = value.blocks[i]?.blockDTOList.length;
      flag = len < 1 ? ++flag : flag; 
      }
    });

    const noContents = totalBlocks === 0 ? true : totalBlocks === flag ;
    const previewPortalContainerId = readOnly ? `preview-portal-${artboardVersion}` : 'preview-portal';
    
    if (docDesign.current && document.getElementById(previewPortalContainerId)) {

      return !noContents || hasSummary ? ReactDOM.createPortal(
        <ComplexDocumentHistoryProvider>
          <ComplexArtboardProvider
            customState={{
              ...OVERRIDE_ARTBOARD_STATE,
              [CONTEXT_KEYS.CURRENT_DESIGN]: currentDesign,
            }}
            customName={'PreviewContext'}
          >
            <BusinessLogicProvider>
              <FontsProvider>
                <DocumentContainer className={'preview'}>
                 { isEmail ? <ComplexEmailArtboard existingDocument={docDesign.current} />:
                 <ComplexArtboard existingDocument={docDesign.current} />}
                </DocumentContainer>
              </FontsProvider>
            </BusinessLogicProvider>
          </ComplexArtboardProvider>
        </ComplexDocumentHistoryProvider>,
        document.getElementById(previewPortalContainerId)
      )
        :
        ReactDOM.createPortal(
          <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }}>
            <img style={{ width: '400px', height: '400px', display: 'flex', justifyContent: 'space-between', marginTop:'120px' }} src={blankCanvas} alt="blank-canvas" />
            <p>
              {t(
                ACCESSIBILITY_TOOL_TIPS.NO_ACCESSIBLE_CONTENT.key,
                ACCESSIBILITY_TOOL_TIPS.NO_ACCESSIBLE_CONTENT.value,
              )} 
            </p>
          </div>,
          document.getElementById('preview-portal'))
    }

    return null;
  };
  

  return (
    <>
      {visible && !showContent && <FullPageLoaderContainer>
        <Loader fullpage="true" />
      </FullPageLoaderContainer>}
      {showContent && visible && !viewImages && !viewContrast && !viewDocSummary && !viewBlockSummary && (
        <ComplexPreviewTabsContainer disabled={!isEditMode}>
          {
            (!accessibilityEnabled && currentDesign === 'document') &&
            <Overlay>
              <OverlayText>{t(
                ACCESSIBILITY_VALIDATOR_TRANSLATION.ENABLE_ACCESSIBILITY_TEXT.key,
                ACCESSIBILITY_VALIDATOR_TRANSLATION.ENABLE_ACCESSIBILITY_TEXT.value,
              )}</OverlayText>
            </ Overlay>
          }
          <div style={{ color: 'white' }}>
            <p style={{ color: 'white', fontSize: '16px', fontWeight: '700', marginTop: '4px' }}>
              {t(
                ACCESSIBILITY_VALIDATOR_TRANSLATION.ENABLE_ACCESSIBLE_DESIGN.key,
                ACCESSIBILITY_VALIDATOR_TRANSLATION.ENABLE_ACCESSIBLE_DESIGN.value,
              )}
            </p>
            <p style={{ color: 'white', fontSize: '14px', marginTop: '6px' }}>
              {t(
                ACCESSIBILITY_VALIDATOR_TRANSLATION.ENABLE_ACCESSIBLE_DESIGN_MESSAGE.key,
                ACCESSIBILITY_VALIDATOR_TRANSLATION.ENABLE_ACCESSIBLE_DESIGN_MESSAGE.value,
              )}
            </p>
          </div>

          <div style={{ marginLeft: '60px' }}>
            {percentageSvg(percentage)}
          </div>
          {
            percentage < 100 ? ImgparentCard()
              :
              <Card bordered={false} className='card-design'>
                <div className='card-heading'>
                  <div>
                    {tickSvg()}
                  </div>
                  <p style={{ color: 'white', fontSize: '16px', fontWeight: '700' }}>
                    {t(
                      ACCESSIBILITY_VALIDATOR_TRANSLATION.ACCESSIBILITY_VALIDATION_SUCCESS_HEADING.key,
                      ACCESSIBILITY_VALIDATOR_TRANSLATION.ACCESSIBILITY_VALIDATION_SUCCESS_HEADING.value,
                    )}
                  </p>
                </div>
                <p style={{ fontSize: '14px' }}>
                  {t(
                    ACCESSIBILITY_VALIDATOR_TRANSLATION.ACCESSIBILITY_VALIDATION_SUCCESS_MESSAGE.key,
                    ACCESSIBILITY_VALIDATOR_TRANSLATION.ACCESSIBILITY_VALIDATION_SUCCESS_MESSAGE.value,
                  )}
                </p>
              </Card>
          }
        </ComplexPreviewTabsContainer>
      )}
      {showContent && visible && (viewImages || viewContrast || viewDocSummary || viewBlockSummary) &&
        <>
          {getTitle()}
        <ComplexPreviewTabsContainer disabled={!isEditMode}>
            {viewDocSummary && childCard('DocumentSummary')}
            {viewBlockSummary && childCard('BlockSummary')}
            {viewImages && childCard('Image')}
            {viewContrast && childCard('Contrast')}
          </ComplexPreviewTabsContainer>
        </>
      }
     {showContent && visible && <ComplexPreviewTabsContainer disabled={!isEditMode}>
        {getAccessibilityDesign()}
      </ComplexPreviewTabsContainer>}
    </>
  );
};

export default ComplexDocumentAccessibilityValidator;